import { ClipboardCheck, ClipboardCopy } from "lucide-react"
import React from "react"

export function CopyPasta({ text }: { text: string }) {
  const [copied, setCopied] = React.useState(false)
  const handleCopy = React.useCallback(() => {
    navigator.clipboard.writeText(text)
    setCopied(true)
    setTimeout(() => setCopied(false), 2000)
  }, [text])

  const Icon = copied ? ClipboardCheck : ClipboardCopy

  return (
    <button
      type="button"
      className="not-prose text-sm w-full text-left md:text rounded border border-zinc-500/20 bg-background p-2 mt-2 flex cursor-pointer"
      onClick={handleCopy}
    >
      <span className="grow shrink-1 font-mono">{text}</span>
      <span className="absolute right-7 px-2 rounded text-muted-foreground bg-background">
        {copied ? "copied!" : ""}
      </span>
      <Icon className="h-5 w-5 text-zinc-500 shrink-0" />
    </button>
  )
}
